module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "CallMe"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('input', {
    ref: "name",
    attrs: {
      "type": "text",
      "placeholder": "Ad Soyad"
    }
  }), _vm._v(" "), _c('input', {
    ref: "subject",
    attrs: {
      "type": "text",
      "placeholder": "Konu"
    }
  }), _vm._v(" "), _c('input', {
    ref: "email",
    attrs: {
      "type": "text",
      "placeholder": "E-Posta"
    }
  }), _vm._v(" "), _c('input', {
    ref: "phone",
    attrs: {
      "type": "text",
      "placeholder": "Telefon Numarasi"
    }
  }), _vm._v(" "), _c('textarea', {
    ref: "message",
    attrs: {
      "rows": "8",
      "placeholder": "Mesajınız"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_vm._v("\n      GÖNDER\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-360dafd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallMe.vue
// module id = 230
// module chunks = 1